export type Brand =
  | 'amex'
  | 'diners'
  | 'visa'
  | 'mastercard'
  | 'discover'
  | 'jcb'
  | 'elo'
  | 'hipercard'
  | 'default';

const BRAND_RULES: Record<
  Brand,
  { pattern: RegExp; groups: number[]; maxLen: number; cvv: number }
> = {
  amex: { pattern: /^3[47]\d*/, groups: [4, 6, 5], maxLen: 15, cvv: 4 },
  diners: {
    pattern: /^(3(?:0[0-5]|09|[68])|39)\d*/,
    groups: [4, 6, 4],
    maxLen: 14,
    cvv: 3,
  },
  visa: { pattern: /^4\d*/, groups: [4, 4, 4, 4, 3], maxLen: 19, cvv: 3 },
  mastercard: {
    pattern: /^(5[1-5]|2[2-7])\d*/,
    groups: [4, 4, 4, 4],
    maxLen: 16,
    cvv: 3,
  },
  discover: {
    pattern: /^(6011|65|64[4-9]|622)\d*/,
    groups: [4, 4, 4, 4],
    maxLen: 19,
    cvv: 3,
  },
  jcb: {
    pattern: /^(?:2131|1800|35)\d*/,
    groups: [4, 4, 4, 4],
    maxLen: 19,
    cvv: 3,
  },
  elo: {
    pattern: /^(4011|438935|4576|504175|5067|509|627780|636368|650|651|655)\d*/,
    groups: [4, 4, 4, 4],
    maxLen: 16,
    cvv: 3,
  },
  hipercard: {
    pattern: /^(606282|3841)\d*/,
    groups: [4, 4, 4, 4],
    maxLen: 16,
    cvv: 3,
  },
  default: { pattern: /^\d*/, groups: [4, 4, 4, 4, 3], maxLen: 19, cvv: 3 },
};

function detectBrand(digits: string): Brand {
  const entries = Object.entries(BRAND_RULES) as [
    Brand,
    (typeof BRAND_RULES)[Brand],
  ][];
  for (const [brand, cfg] of entries)
    if (cfg.pattern.test(digits)) return brand;
  return 'default';
}

export function formatCardNumber(raw: string) {
  const digits = raw.replace(/\D/g, '');
  const brand = detectBrand(digits);
  const cfg = BRAND_RULES[brand];
  const cut = digits.slice(0, cfg.maxLen);

  const groups: string[] = [];
  let idx = 0;
  for (const size of cfg.groups) {
    if (idx >= cut.length) break;
    const part = cut.slice(idx, idx + size);
    if (!part) break;
    groups.push(part);
    idx += size;
  }
  if (idx < cut.length) groups.push(cut.slice(idx));
  return { formatted: groups.join(' '), brand, rawDigits: cut };
}

export const cvvMaxForBrand = (brand: Brand) => BRAND_RULES[brand].cvv;
